// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.AccessHeader.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ScheduleContainer component
 */

import React from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import ReportNameEditor from 'modules/ReportDesigner/Izenda.ReportNameEditor';
import Validator from 'share/components/hoc/Izenda.Validator';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import localizer from 'share/localization/Izenda.Localizer';
import UserLookUp from 'modules/User/Izenda.UserLookUp';
import CONSTANT from 'logic/data/Izenda.AccessConstants';
import { isEmpty } from 'lodash/fp';

const AccessHeader = (props: any) => {
  const { store: reportStore } = props;
  const { model, accessStore } = reportStore;
  const owner = isEmpty(model.ownerId)
    ? []
    : [
        {
          id: model.ownerId,
          name: model.owner
        }
      ];

  return (
    <GridLayout>
      <GridLayout.Row>
        <GridLayout.Col cols={model.isGlobal ? 12 : 6}>
          <ReportNameEditor
            accessPage
            store={reportStore}
            name={model.reportName}
            showTooltip={false}
            isPreviewRecord={false}
          />
        </GridLayout.Col>
        {!model.isGlobal && (
          <GridLayout.Col cols="6">
            <div className="form-horizontal u_marginBottom">
              <div className="form-group u-bgWhite u_paddingInner u_noMarginAll">
                <GridLayout.Col cols="1">
                  <label className="control-label">{localizer.getText('COMMON_LABEL_OWNER')}</label>
                </GridLayout.Col>
                <GridLayout.Col cols="11">
                  <UserLookUp
                    usedCurrentUser
                    useSearchName
                    data={accessStore.users.peek()}
                    value={owner}
                    usingPopup={true}
                    onChange={model.updateReportOwner.bind(model)}
                    onChangeFromPopup={model.updateReportOwner.bind(model)}
                    valueField="id"
                    textField="name"
                    singleUser
                    validations={CONSTANT.CONSTRAINTS.REPORT_OWNER}
                    field="owner"
                    userModeType={CONSTANT.USER_ACCESS_MODE.ACCESS}
                    useEmailInOptions
                  />
                </GridLayout.Col>
              </div>
            </div>
          </GridLayout.Col>
        )}
      </GridLayout.Row>
    </GridLayout>
  );
};

AccessHeader.propTypes = {
  store: React.PropTypes.object.isRequired
};

export default connect()(AccessHeader);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Access/Izenda.AccessHeader.jsx